import siteConfigService from '@/services/site.config.service';

class FaviconService {
  private faviconUrlApiEndpointKeyName: string = 'faviconUrl';

  public async getFaviconIcon(): Promise<string> {
    return siteConfigService.getApiEndpoint(this.faviconUrlApiEndpointKeyName);
  }
}

// Export a singleton instance in the global namespace
export const faviconService = new FaviconService();
